<template>
	<div class="icon-button" @click="$emit('click', $event)">
		<div class="icon-button__label" v-if="label">{{ label }}</div>
		<svgicon class="icon-button__icon" v-if="icon" :icon="icon" />
	</div>
</template>

<script>
	import ButtonView from './ButtonView'

	export default {
		extends: ButtonView,
		props: ['icon']
	}
</script>

<style>
	.icon-button {
		position: relative;
		cursor: pointer;
	}

	.icon-button__icon {
		position: absolute;
		width: 18px;
		height: 18px;
		top: 50%;
		left: 50%;
		margin-top: -8px;
		margin-left: -8px;
		fill: #15161a;
	}
</style>
